import { useQuery } from '@tanstack/react-query'
import { listSavedFilters } from '../api'

export const savedFiltersQueryKey = ['alerts', 'saved-filters'] as const

export function useSavedFilters() {
  return useQuery({
    queryKey: savedFiltersQueryKey,
    queryFn: listSavedFilters,
    staleTime: 60_000,
    select: (data) => data.saved_filters,
  })
}
